import styled from 'styled-components';

export interface ContainerProps {
  $transitionDuration?: number;
}

export const Container = styled.div<ContainerProps>`
  overflow: hidden;
  transition: ${props => props.theme.transitionTiming};
  ${props => props.$transitionDuration && 'transition-duration: ' + props.$transitionDuration + 'ms '};
`;
